import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';

import { useApplicationContext } from '../../utils/applicationContext';

/**
 * Ошибка некритичного блока (галерея, карта, генплан, реклама) без этой обёртки
 * доходит до корневого ErrorLogComponent и стирает всю карточку.
 */
export const BlockErrorBoundary: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { logger } = useApplicationContext();

  return <ErrorLogComponent logger={logger}>{children}</ErrorLogComponent>;
};
